// Branded placeholder shown when a product image URL is dead / 404 / 410.
// Inline SVG data URI so it works offline & needs no extra network hop.
export const IMG_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#1a1a1c"/>
          <stop offset="1" stop-color="#0F0F10"/>
        </linearGradient>
      </defs>
      <rect width="400" height="500" fill="url(#g)"/>
      <g fill="none" stroke="#4ADE80" stroke-width="1.5" opacity="0.55">
        <circle cx="200" cy="220" r="46"/>
        <path d="M200 174v92 M154 220h92" stroke-opacity="0.35"/>
      </g>
      <text x="200" y="320" text-anchor="middle" fill="#4ADE80"
        font-family="'Space Grotesk', system-ui, sans-serif"
        font-size="12" letter-spacing="4">ENDA G1</text>
      <text x="200" y="342" text-anchor="middle" fill="#7a7a7a"
        font-family="'Space Grotesk', system-ui, sans-serif"
        font-size="10" letter-spacing="3">IMAGE UNAVAILABLE</text>
    </svg>`
  );

// Attach to any <img>: onError={handleImgError}
export function handleImgError(e) {
  const el = e.currentTarget;
  if (el.dataset.fallbackApplied === "1") return;
  el.dataset.fallbackApplied = "1";
  el.src = IMG_FALLBACK;
}
